import React, { useEffect, useState } from "react";
import LandingHeader from "../Components/LandingHeader";
import { Accordion, Col, Container, Row } from "react-bootstrap";
import { Images } from "../Components/Images";
import BlogCard from "../Components/BlogCard";
import { allData } from "../Components/CommonData";
import BenefitCard from "../Components/BenefitCard";
import ReviewCard from "../Components/ReviewCard";
import Marquee from "react-fast-marquee";
import Footer from "../Components/Footer";
import InnerFooter from "../Components/InnerFooter";
import OldLanding from "../Components/OldLanding";
import Header from "../layout/Header";
import Banner from "../Components/Banner";
import Marque from "../Components/Marque";
import SectionOne from "../Components/SectionOne";
import SectionTwo from "../Components/SectionTwo";
import SectionThree from "../Components/SectionThree";
import SectionFour from "../Components/SectionFour";
import Articles from "../Components/Articles";
import FrequentlyAskQus from "../Components/FrequentlyAskQus";
import NewFooter from "../layout/Footer";
import About from "../Components/About";
import Services from "../Components/Services";
import JoinFlashChain from "../Components/JoinFlashChain";
import CryptoTrading from "../Components/CryptoTrading";
import Benefits from "../Components/Benefits";
import Testimonial from "../Components/Testimonial";
import HowItWorks from "../Components/HowItWorks";
import { getCMS } from "../actions/settings";
import { getAllFAQ } from "../actions/settings";
import { getUserBycode } from "../actions/user";
import { getOwnerAccount } from "../Hooks/UseContract";

const Landing = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  const [cmsLits, setcmsLits] = useState([]);
  const [faqLits, setfaqLits] = useState([]);

  const getCMSData = async () => {
    let { status, message, data, count } = await getCMS();

    if (status == "success") {
      setcmsLits(data);
    }
  };

  const getFAQData = async () => {
    let { status, message, data, count } = await getAllFAQ();
    console.log(
      "~ getCMSData ~ status, message, data, count:",
      status,
      message,
      data,
      count
    );
    if (status == "success") {
      setfaqLits(data);
    }
  };

  useEffect(() => {
    getCMSData();
    getFAQData();
    UserDatabyCode()
  }, []);


  const UserDatabyCode = async () => {

    const referrerId = window.location.pathname.split("/")[3];
    console.log("UserDatabyCodestatus>>>>>>>>", referrerId);
    let userdata = await getUserBycode({ referralCode: referrerId });
    console.log("UserDatabyCodestatus>>>>>>>", userdata?.result?.walletAddress);
    let adminWalletAddress = await getOwnerAccount();
    const referrerAddress = referrerId ? userdata?.result?.walletAddress : adminWalletAddress;
    localStorage.setItem("referrerFeeAccount", referrerAddress)
  };

  return (
    <div className="landing_sec">
      <div className="banner_bgVideo">
        <video
          src={Images.bannerBg_vdo}
          autoPlay
          muted
          loop
          className="img-fluid video_src"
        />
        <div className="overlay_bg" />
        {/* <img src={Images.BnrYlwOvlw1} className="yellow_overlay1 img-fluid" />
        <img src={Images.BnrYlwOvlw2} className="yellow_overlay2 img-fluid" /> */}
        <div className="yellow_overlay1"></div>
        <Header />
        <Banner cmsLits={cmsLits} />
        {/* <Marque /> */}
      </div>
      <About cmsLits={cmsLits} />
      <Services cmsLits={cmsLits} />
      <JoinFlashChain cmsLits={cmsLits} />
      <HowItWorks cmsLits={cmsLits} />
      <Benefits cmsLits={cmsLits}
      />
      <Testimonial cmsLits={cmsLits} />
      <CryptoTrading cmsLits={cmsLits} />
      <div className="joinFlash_bgVideo">
        {/* <video
          src={Images.joinFlash_bgVideo}
          autoPlay
          muted
          loop
          className="img-fluid video_src"
        />
        <div className="overlay_bg" /> */}

        <FrequentlyAskQus
          cmsLits={cmsLits}
          faqLits={faqLits} />
      </div>

      <NewFooter cmsLits={cmsLits} />
    </div>
  );
};

export default Landing;
